export const FORM_ITEM_TYPES = {
  TEXT: 'input',
  SELECT: 'select',
  NUMBER: 'number_input',
  MOBILE: 'mobile',
  MOBILE_SEARCH: 'mobile_search',
  QUICK_ADDRESS_SEARCH: 'quick_address_search'
}
